import { DiscountScale } from '@photosi/expo-photosi-sdk/build/Project';

export function useDiscountInfo(quantity: number, discount: DiscountScale[]) {
  let currentTier = discount && discount[0];
  let nextTier = (discount && discount[1]) || null;
  let currentIndex = 0;

  for (let i = 0; i < discount.length; i++) {
    const item = discount[i];

    if (item.to !== undefined && quantity >= item.from && quantity <= item.to) {
      currentTier = item;
      nextTier = discount[i + 1] || null;
      currentIndex = i;
      break;
    }

    if (item.to === undefined && quantity >= item.from) {
      currentTier = item;
      nextTier = null;
      currentIndex = i;
      break;
    }

    if (quantity < discount[0].from) {
      currentTier = discount[0];
      nextTier = discount[1] || null;
      currentIndex = -1;
    }
  }

  const missingForNext = nextTier ? Math.max(nextTier.from - quantity, 0) : null;

  let progress = 0;

  if (quantity > 0) {
    if (!!nextTier) {
      const tierStart = currentTier?.from;
      const tierEnd = nextTier.from ? nextTier.from : tierStart;
      const ratio = (quantity - tierStart + 1) / (tierEnd - tierStart + 1);
      const totalSteps = discount.length - 1;
      const intervalMin = (currentIndex / totalSteps) * 100;
      const intervalMax = ((currentIndex + 1) / totalSteps) * 100;
      progress = intervalMin + ratio * (intervalMax - intervalMin);
    } else {
      progress = 100;
    }
  }

  return {
    discountValue: currentTier?.discount,
    nextDiscount: nextTier?.discount,
    missingForNext,
    progress,
  };
}
